/**
 * Seleciona a taxa apropriada (bid ou ask) baseada no tipo de operação
 * @param {Array|Object} rates - array ou objeto de rate (RateDTO)
 * @param {Boolean} exchangeBuy - tipo de operação
 * @returns {Number} cotação selecionada com base no tipo de operação
 */
function selectRate(rates, exchangeBuy) {
  const rate = Array.isArray(rates) ? rates?.[0] : rates;
  
  if (exchangeBuy) {
    return rate?.bid || 0;
  } else {
    return rate?.ask || 0;
  }
}

export default {
  selectRate,
};
